<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- APP TITLE -->
                <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        person
                    </mat-icon>
                    <span class="logo-text h1">
                        Usuários
                    </span>

                    <!-- BOTÕES DE AÇÃO -->
                    <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                        <!-- BOTÃO CONSULTAR -->
                        <button mat-mini-fab color="accent" matTooltip="Consultar Usuário" (click)="openFiltro()">
                            <mat-icon>search</mat-icon>
                        </button>

                        <!-- BOTÃO ADICIONAR -->
                        <button mat-mini-fab color="accent" matTooltip="Adicionar Usuário" (click)="openCadastro()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <input #filter placeholder="Buscar Por Nome ou CPF" [formControl]="search"
                        (keyup)="onEnter(filter.value)" (keyup.enter)="onEnter(filter.value)">
                    <mat-icon style="cursor: pointer;" (click)="onEnter()">
                        search
                    </mat-icon>
                </div>
            </div>
            <!-- / SEARCH -->
        </div>

        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-tab-group>
                <mat-tab class="accent title" label="Ativos">
                    <ng-template matTabContent>
                        <app-usuarios-lista-tabela [params]="params" [deleted]="false"></app-usuarios-lista-tabela>
                    </ng-template>
                </mat-tab>
                <mat-tab class="accent title" label="Inativos">
                    <ng-template matTabContent>
                        <app-usuarios-lista-tabela [params]="params" [deleted]="true"></app-usuarios-lista-tabela>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>